export default "__VITE_ASSET__DBvtu8D1__"